import axios from "@/axios"

const url = "/api/brain/specimens/gender-weight"

class GenderWeightService {
	async getGenderWeights() {
		try {
			const { data } = await axios.get(`${url}`)
			return data
		} catch (error) {
			throw error
		}
	}

	async updateGenderWeight(params) {
		try {
			const { data } = await axios.put(`${url}`, params)
			return data
		} catch (error) {
			throw error
		}
	}
}

export default new GenderWeightService()
